export enum VerificationStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum DocumentType {
  IdentityCard = 0,
  Passport = 1,
  DriverLicense = 2,
}

export interface VerificationRequest {
  nameOrther: string;
  nationName: string;
  referenceLinks: string[];
  status: VerificationStatus;
  documentType: DocumentType;
  documentLink: string;
}
